define(["dojo/query","/app/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js",""], function(loader, runner) {
   return runner(loader, "css2", __webpack_require__.dj.c(), false);
});